<style lang="less" scoped>
@import "../../styles/variable.less";
#product-list {
  padding-bottom: 5px;
  /deep/ .product-item,
  /deep/ .product-link {
    display: flex;
    & > * {
      flex: 1 1 100%;
    }
  }
  /deep/ .ant-card {
    border-radius: 5px;
    padding: 5px;
    &-body {
      padding: 15px 10px;
    }
    &-cover {
      position: relative;
      .product-thumbnail {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        max-height: 160px;
        border-radius: 5px;
        border: solid 1px @clear-black02;
        overflow: hidden;
        vertical-align: bottom;
      }
      .ant-image {
        opacity: 0;
      }
    }
    &-meta {
      &-title {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 0;
        a {
          color: inherit;
        }
      }
    }
    .taglist {
      margin: 0;
      padding: 0;
      &-item {
        display: inline-block;
        font-size: 12px;
        color: @gray01;
        white-space: nowrap;
        margin-top: 5px;
        &:after {
          content: ",";
          display: inline-block;
          color: @gray03;
          margin: 0 5px;
        }
        &:last-child {
          &:after {
            content: none;
          }
        }
      }
    }
    .data-overlay {
      background: rgba(@white01, 0.9);
      display: flex;
      align-items: center;
      font-size: 12px;
      width: 100%;
      padding: 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      &-text {
        flex-grow: 1;
        padding-left: 5px;
        margin-bottom: 0;
      }
      &-btn {
        background: none;
        color: @blue01;
        width: auto;
        height: auto;
        padding: 3px 12px;
        border: solid 1px;
        border-radius: 5px;
      }
    }
  }
}
</style>
<template>
  <div id="product-list" v-if="clientUserGroup != null">
    <a-row :gutter="[10, 10]">
      <a-col
        class="product-item"
        v-for="product in products"
        :key="product.id"
        :span="6"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="6"
        :xxl="4"
      >
        <a-button type="link" @click="handleClick(product.id)">
          <!-- <router-link
          class="product-link"
          :to="{
            name: 'ProductDetail',
            params: {
              clientUserGroupId: clientUserGroupId,
              id: product.id,
            },
          }"
        > -->
          <a-card hoverable>
            <template #cover>
              <div
                class="product-thumbnail"
                :style="{
                  backgroundImage:
                    'url(' + (product.thumbnailPath || fallbackImage) + ')',
                }"
              >
                <a-image
                  width="100%"
                  :src="product.thumbnailPath || fallbackImage"
                  :fallback="fallbackImage"
                  :preview="false"
                />
              </div>
            </template>
            <a-card-meta>
              <template #title>{{ product.name }}</template>
              <template #description>
                {{ product.note }}
                <ul class="taglist">
                  <li
                    class="taglist-item"
                    v-for="tag in product.tags"
                    :key="tag"
                  >
                    {{ tag.name }}
                  </li>
                </ul>
              </template>
            </a-card-meta>
          </a-card>
          <!-- </router-link> -->
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, SetupContext, unref } from "vue";
import { useResult } from "@vue/apollo-composable";
import { useRouter } from "vue-router";
import { useGetOneClientUserGroupQuery } from "@/client/modules/api";
import { GetOneClientUserGroupQuery, ProductType } from "@/client/schema";

export type Props = {
  clientUserGroupId: string;
  productCategoryId?: string;
  fromParent?: boolean;
};

const fallbackImage =
  "data:image/png;base64,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";

export default defineComponent({
  components: {},
  props: {
    clientUserGroupId: {
      type: String,
      required: true,
    },
    productCategoryId: {
      type: String,
      required: false,
    },
    fromParent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props: Props, { emit }: SetupContext) {
    const { result } = useGetOneClientUserGroupQuery({
      id: props.clientUserGroupId,
    });
    const clientUserGroup =
      useResult<GetOneClientUserGroupQuery, "clientUserGroup">(result);

    const products = computed(() => {
      const _clientUserGroup = unref(clientUserGroup);
      if (_clientUserGroup == null) return [];
      if (props.fromParent) {
        return _clientUserGroup.products.filter(
          (product) =>
            product.productType !== ProductType.Normal &&
            product.productType !== ProductType.Draft
        );
      }
      if (props.productCategoryId == null) return _clientUserGroup.products;
      return _clientUserGroup.products.filter(
        (product) => product.category?.id === props.productCategoryId
      );
    });

    const router = useRouter();
    const handleClick = (productId: string) => {
      if (props.fromParent) {
        emit("select", productId);
      } else {
        router.push({
          name: "ProductDetail",
          params: {
            clientUserGroupId: props.clientUserGroupId,
            id: productId,
          },
        });
      }
    };

    return {
      clientUserGroup,
      fallbackImage,
      products,
      handleClick,
    };
  },
});
</script>
